import { DateTime, Duration } from 'luxon';

export const getSmartFutureTimeLabel = (isoDateTime?: string | null) => {
  if (isoDateTime === null || isoDateTime === undefined) {
    // eslint-disable-next-line no-console
    console.error(`getSmartFutureTimeLabel: missing isoDateTime = ${isoDateTime}`);
    return '';
  }

  const now = DateTime.local();
  const dateTime = DateTime.fromISO(isoDateTime, { zone: 'utc' });

  if (dateTime.isValid && dateTime > now) {
    const duration = Duration.fromMillis(dateTime.toMillis() - now.toMillis());
    const minutes = Math.floor(duration.as('minutes'));

    if (minutes < 1) {
      return 'less than a minute';
    } else if (minutes < 60) {
      return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    } else {
      const hours = Math.floor(duration.as('hours'));
      if (hours < 24) {
        return `${hours} hour${hours > 1 ? 's' : ''}`;
      } else {
        const days = Math.floor(duration.as('days'));
        if (days < 365) {
          return `${days} day${days > 1 ? 's' : ''}`;
        } else {
          return dateTime.toLocaleString(DateTime.DATE_SHORT); // Default for large future dates (over a year)
        }
      }
    }
  } else {
    return '-';
  }
};
